<template>
  <div class="topbar-container bg-light">
    <div class="fixed-top py-4 py-md-3 bg-white shadow-sm">
      <div class="container text-center position-relative">
        <a href="javascript:" @click="voltar" class="btn position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar">
          <i class="fa fa-chevron-left text-dark"></i>
          <span class="d-none d-md-inline-block font-weight-bold ml-2">Voltar</span>
        </a>
        <div class="font-weight-bold m-auto" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; height: 24px">
          {{title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from './Icon'
  export default {
    name: "TopBar",
    components: {Icon},
    props: ['title', 'link', 'event'],
    data() {
      return {
        sacola: true,
        token: localStorage.getItem('token'),
      }
    },

    methods: {
      voltar() {
        if (this.event) {
          this.$emit('voltar');

        } else if (this.link) {
          const url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
          this.$router.push(url + '/home');

        } else {
          this.$router.go(-1);
        }
      }
    }
  }
</script>

<style scoped>
  .topbar-container {
    padding-bottom: 88px;
  }

  .topbar-container.no-padd {
    padding-bottom: 0!important;
  }

  .topbar-container .btn {
    border: 1px solid #e9ecef;
  }

  @media (min-width: 900px) {
    .topbar-container {
      padding-bottom: 75px
    }

    .topbar-container .btn {
      border: none;
      border-radius: 12px!important;
    }
  }
</style>
